import {
  SegmentedControl as MantineSC,
  SegmentedControlItem,
} from '@mantine/core';

import classes from './segmentedControl.module.scss';

export type SegmentedControlProps = {
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  options: SegmentedControlItem[];
  value?: string;
};

export const SegmentedControl = ({
  className,
  defaultValue,
  disabled,
  onChange,
  options,
  value,
}: SegmentedControlProps) => {
  return (
    <MantineSC
      attributes={{
        indicator: { 'data-testid': 'segmented-control-indicator' },
      }}
      className={className}
      classNames={classes}
      data={options}
      defaultValue={defaultValue}
      disabled={disabled}
      onChange={onChange}
      value={value}
      withItemsBorders={false}
    />
  );
};
